import Vue from 'vue'
import Api from './plugins/api'

import store from './store'

// Create api instance
Vue.use(Api)
const api = new Api()

export default api
export { api }